import { VisibilityIcon } from '../Icon/VisibilityIcon';
import { VisibilityOffIcon } from '../Icon/VisibilityOffIcon';
import styles from './SecretValue.module.css';
import { useState } from 'react';

interface Props {
  value: string;
}

export function SecretValue({ value }: Props) {
  const [isVisible, setIsVisible] = useState(false);

  const Icon = isVisible ? VisibilityOffIcon : VisibilityIcon;

  function toggle() {
    setIsVisible(p => !p);
  }

  return (
    <div className={styles.secretValue}>
      <span>{isVisible ? value : '********'}</span>

      <button onClick={toggle}>
        <Icon className={styles.icon} />
      </button>
    </div>
  );
}
